import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import {
  ErrorSnacktOpen,
} from "../../ErrorSnack/actions";
const download = require("downloadjs");
import axios from 'axios';

// //////////////////
// Action Creators //
// //////////////////

export const CambiarInicioVigencia = (inicioVigenciaPaquete, error) => ({
  type: "CAMBIAR_INICIO_VIGENCIA",
  inicioVigenciaPaquete,
  error,
});

export const filtroBusqueda = () => ({
  type: "FILTRO_BUSQUEDA",
});

export const cargarPaqueteGES = (paquetes) => ({
  type: "CARGAR_PAQUETE_GES",
  paquetes,
});

export const cargarTiposAtencion = (tiposAtencion) => ({
  type: "CARGAR_TIPOS_ATENCION",
  tiposAtencion,
});

export const cargarProblemasSalud = (problemasSalud) => ({
  type: "CARGAR_PROBLEMAS_SALUD",
  problemasSalud,
});
export const cargarIntSanitarias = (intSanitarias) => ({
  type: "CARGAR_INTERVENCIONES_SANITARIAS",
  intSanitarias,
});
export const cargarCanastas = (canastas) => ({
  type: "CARGAR_CANASTAS",
  canastas,
});

export const cargarNuevaPrestacion = (modalNuevaPrestacion) => ({
  type: "CARGAR_NUEVA_PRESTACION",
  modalNuevaPrestacion,
});

export const CambiarTipoAtencion = (tipoAtencion) => ({
  type: "CAMBIAR_TIPO_ATENCION",
  tipoAtencion,
});

export const CambiarCanasta = (canasta) => ({
  type: "CAMBIAR_CANASTA",
  canasta,
});

export const CambiarCodIsapre = (codIsapre) => ({
  type: "CAMBIAR_CODIGO_ISAPRE",
  codIsapre,
});

export const CambiarIntSanitaria = (intervencionSanitaria) => ({
  type: "CAMBIAR_CODIGO_INTERVENCION",
  intervencionSanitaria,
});

export const CambiarCodPrestador = (codPrestador) => ({
  type: "CAMBIAR_CODIGO_PRESTADOR",
  codPrestador,
});

export const CambiarProblemaSalud = (problemaSalud) => ({
  type: "CAMBIAR_PROBLEMA_SALUD",
  problemaSalud,
});

export const CambiarGlosa = (glosa) => ({
  type: "CAMBIAR_GLOSA_PAQUETE",
  glosa,
});

export const LimpiarCanastas = () => ({
  type: "LIMPIAR_CANASTAS",
});

export const Loading = (loading) => ({
  type: "LOADING",
  loading,
});

export const LoadingExcel = (loadingExcel) => ({
  type: "LOADINGEXCEL",
  loadingExcel,
});

export const CargarSolicitudes = (solicitudes) => ({
  type: "CARGAR_SOLICITUDES",
  solicitudes,
});

export const OpenCargarBorrador = (modalAction) => ({
  type: "OPEN_CARGAR_BORRADOR",
  modalAction,
});

export const CargarDetalleSolicitud = (prestacionesSolicitud, idSolicitud) => ({
  type: "CARGAR_DETALLE_SOLICITUD_FIL",
  prestacionesSolicitud,
  idSolicitud,
});

export const SetSolicitudesEnCurso = (solicitudEnCurso) => ({
  type: "ACT_ARANCEL_SET_SOLICITUD_EN_CURSO",
  solicitudEnCurso,
});

export const cargarPaginacion = (paginacion) => ({
  type: "CARGAR_PAGINACION_PG",
  paginacion,
});


// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const BuscarPaqueteGES = (value) => (dispatch) => {
  const filtrosState = store.getState().filtroBusquedaAG.filtros;
  const globalState = store.getState().global;

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    SecInstitucion: globalState.filtros_CAT.centroAtencion,
    ProbSalud: filtrosState.problemaSalud,
    IntSanitaria: filtrosState.intervencionSanitaria,
    Canasta: filtrosState.canasta,
    TipoAtencion: filtrosState.tipoAtencion,
    CodPrestador: filtrosState.codPrestador,
    Isapre: globalState.isapre,
    pageNumber: 1,
    pageSize: 5,
    token: globalState.token,
  };
  //console.log("PARAMETROS ANTES DE AXIOS");
  //console.log(params);
  axios({
    method: "post",
    url: `${apiConfig.apiUri}/v1/GES/paqueteGES/`,
    credentials: "same-origin",
    data: { data: JSON.stringify(params) },
  }).then((response) => {
    if (response.status === 200) {
      //console.log("RESPONSE OK");
      //console.log(response.data);

      if (Array.isArray(response.data)) {
        //trace.information("BuscarPaqueteGES", response.data);
        dispatch(cargarPaqueteGES(response.data));
        dispatch(Loading(false));
      } else {
        throw response.data;
      }
    }
  }).catch((error) => {
    if (error.response) {
      console.log("MENSAJE DE Error 4xx");
      console.log(error);
    } else {
      console.log("MENSAJE DE Error 5xx");
      console.log(error);
    }
    trace.error("BuscarArancelGES", error);
    dispatch(ErrorSnacktOpen(
      "Error al buscar las prestaciones:",
      error,
    ));
  });
};

export const BuscarTotalPaginas = (value) => (dispatch) => {
  const filtrosState = store.getState().filtroBusquedaAG.filtros;
  const globalState = store.getState().global;

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    SecInstitucion: globalState.filtros_CAT.centroAtencion,
    ProbSalud: filtrosState.problemaSalud,
    IntSanitaria: filtrosState.intervencionSanitaria,
    Canasta: filtrosState.canasta,
    TipoAtencion: filtrosState.tipoAtencion,
    CodPrestador: filtrosState.codPrestador,
    Isapre: globalState.isapre,
    pageSize: 5,
    token: globalState.token,
  };
  //console.log("PARAMETROS ANTES DE AXIOS");
  //console.log(params);
  axios({
    method: "post",
    url: `${apiConfig.apiUri}/v1/GES/total-registros-pg/`,
    credentials: "same-origin",
    data: { data: JSON.stringify(params) },
  }).then((response) => {
    if (response.status === 200) {
      //console.log("RESPONSE OK");
      //console.log(response.data);

      if (Array.isArray(response.data)) {
        //trace.information("BuscarArancelGES", response.data);
        dispatch(cargarPaginacion(response.data));
      } else {
        throw response.data;
      }
    }
  }).catch((error) => {
    if (error.response) {
      console.log("MENSAJE DE Error 4xx");
      console.log(error);
    } else {
      console.log("MENSAJE DE Error 5xx");
      console.log(error);
    }
    trace.error("BuscarArancelGES", error);
    dispatch(ErrorSnacktOpen(
      "Error al buscar las prestaciones:",
      error,
    ));
  });
};

export const BuscarPaqueteGESPP = (pagina, totalPagina) => (dispatch) => {
  const filtrosState = store.getState().filtroBusquedaAG.filtros;
  const globalState = store.getState().global;

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    SecInstitucion: globalState.filtros_CAT.centroAtencion,
    ProbSalud: filtrosState.problemaSalud,
    IntSanitaria: filtrosState.intervencionSanitaria,
    Canasta: filtrosState.canasta,
    TipoAtencion: filtrosState.tipoAtencion,
    CodPrestador: filtrosState.codPrestador,
    Isapre: globalState.isapre,
    pageNumber: pagina,
    pageSize: totalPagina,
    token: globalState.token,
  };
  //console.log("PARAMETROS ANTES DE AXIOS");
  //console.log(params);
  axios({
    method: "post",
    url: `${apiConfig.apiUri}/v1/GES/paqueteGES/`,
    credentials: "same-origin",
    data: { data: JSON.stringify(params) },
  }).then((response) => {
    if (response.status === 200) {
      //console.log("RESPONSE OK");
      //console.log(response.data);

      if (Array.isArray(response.data)) {
        //trace.information("BuscarPaqueteGES", response.data);
        dispatch(cargarPaqueteGES(response.data));
        dispatch(Loading(false));
      } else {
        throw response.data;
      }
    }
  }).catch((error) => {
    if (error.response) {
      console.log("MENSAJE DE Error 4xx");
      console.log(error);
    } else {
      console.log("MENSAJE DE Error 5xx");
      console.log(error);
    }
    trace.error("BuscarArancelGES", error);
    dispatch(ErrorSnacktOpen(
      "Error al buscar las prestaciones:",
      error,
    ));
  });
};

export const obtenerTiposAtencion = () => (dispatch) => {
  //trace.information("obtenerTiposAtencion [Se carga la función ObtenerTiposAtencion]");
  const globalState = store.getState().global;
  const params = {
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/GES/tipoAtencion/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("obtenerTiposAtencion", json);
        dispatch(cargarTiposAtencion(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("obtenerTiposAtencion", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener los tipos de atención:",
        error,
      ));
    });
};

export const obtenerProblemasSalud = () => (dispatch) => {
  //trace.information("obtenerProblemasSalud [Se carga la función obtenerProblemasSalud]");
  const globalState = store.getState().global;
  const params = {
    token: globalState.token,
    Isapre: globalState.isapre
  };

  fetch(`${apiConfig.apiUri}/v1/GES/problemaSalud/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("obtenerProblemasSalud", json);
        dispatch(cargarProblemasSalud(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("obtenerProblemasSalud", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener los problemas de salud:",
        error,
      ));
    });
};

export const obtenerIntSanitarias = () => (dispatch) => {
  //trace.information("obtenerIntSanitarias [Se carga la función obtenerIntSanitarias]");
  const globalState = store.getState().global;
  const params = {
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/GES/intSanitaria/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("obtenerIntSanitarias", json);
        dispatch(cargarIntSanitarias(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("obtenerIntSanitarias", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener las intervenciones sanitarias:",
        error,
      ));
    });
};

export const obtenerCanastas = () => (dispatch) => {
  //trace.information("obtenerCanastas [Se carga la función obtenerCanastas]");
  const filtrosState = store.getState().filtroBusquedaPG.filtros;
  const globalState = store.getState().global;
  const params = {
    ProbSalud: filtrosState.problemaSalud,
    IntSanitaria: filtrosState.intervencionSanitaria,
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/GES/canastas/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("obtenerCanastas", json);
        dispatch(cargarCanastas(json));
        dispatch(CambiarCanasta(0));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("obtenerCanastas", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener las canastas:",
        error,
      ));
    });
};


export const GetSolicitudesExcel = () => (dispatch) => {
  const filtrosState = store.getState().filtroBusquedaAG.filtros;
  const globalState = store.getState().global;

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    SecInstitucion: globalState.filtros_CAT.centroAtencion,
    ProbSalud: filtrosState.problemaSalud,
    IntSanitaria: filtrosState.intervencionSanitaria,
    Canasta: filtrosState.canasta,
    TipoAtencion: filtrosState.tipoAtencion,
    CodPrestador: filtrosState.codPrestador,
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  axios.post(`${apiConfig.apiUri}/v1/GES/paqueteGESExcel/`, { data: JSON.stringify(params) }, { responseType: "blob" })
    .then((response) => {
      if (response.status !== 200) {
        throw response.data;
      }
      dispatch(LoadingExcel(false));
      download(response.data, `paqueteGes_${(new Date()).toLocaleDateString()}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    }).catch((error) => {
      dispatch(LoadingExcel(false));
      trace.error("GetSolicitudesExcel", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener el archivo de las prestaciones:",
        error,
      ));
    });
};
